module.exports = __webpack_public_path__ + "static/media/steps_icon6.6c8e8e24.svg";